import { ApiResponse } from "../types/api-response"
import { TopFilterOutput } from "./useTopFilter"
import useAuth from "./useAuth"
import useSWR from "swr"

export interface ncrNotificationsResponse {
  uuid: string
  type: "Alert" | "Announcement"
  message: string
  created_at: string
  updated_at: string
  deleted_at: any
  mil: Mil
  cem: Cem
}

interface Mil {
  uuid: string
  name: string
}

interface Cem {
  uuid: string
  name: string
}
 
const useNotifications = () => {
  const { fetcher } = useAuth()
//   const { _type, time, ...data } = filter
  const url = "/ncr/notifallperiods/"
  const output = useSWR(url, (url, data) =>
    fetcher()
      .get<ApiResponse<ncrNotificationsResponse[]>>(url, )
      .then(({ data }) => data.data)
  )
  return output
}

export default useNotifications
